import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Content from './Content';

const useStyles = makeStyles((theme) => ({
  
}));

function SystemNotifications(props) {
  const classes = useStyles();
  return (
    <Content>
      <h1>SystemNotifications</h1>
    </Content>
  );
}

export default SystemNotifications;
